import { CreateBeneficiary } from "@/modules/beneficiary/components";
import { PageHeader } from "@/shared/components";

export const CreateBeneficiaryPage = () => (
  <div className="full-width page-container">
    <PageHeader/>
    <CreateBeneficiary/>
  </div>
);
